import React, { Fragment, useRef, useEffect } from "react";

import { Container, Row, Col, CardBody, Card, CardTitle } from "reactstrap";
import TableComponent from "./Components/TableComponent";

const IndexView = (props) => {
  const activeRef = useRef();

  let queryParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    return () => {
      console.log("unmount");
    };
  }, []);

  const reloadInactiveRef = () => activeRef.current.setTokenAPI();

  return (
    <Fragment>
      <Container fluid>
        <Row>
          <Col xs="12">
            <Card className="">
              <CardBody>
                <div className="float-end"></div>
                <CardTitle>Daftar Pegawai PPPK</CardTitle>
                <hr />
                <TableComponent ref={activeRef} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default IndexView;
